import { Reducer } from 'redux';
import { Action, ActionType } from '../../actions';
import { EditorData } from '../../state/TicketTLOV2/EditorData';

const updateTicketTTLOV2EditorData: Reducer<EditorData> = (state: EditorData = new EditorData(), action: Action<ActionType, EditorData>) => {
  switch (action.type) {
    case ActionType.TTLO_V2_EDITOR_DATA_RESET:
      return new EditorData();
    case ActionType.TTLO_V2_EDITOR_DATA_FETCHED:
      return { ...state, ticketTLOV2EditorData: action.data };
    case ActionType.TTLO_V2_EDITOR_DATA_COPIED:
      return { ...state, ticketTLOV2EditorData: { ...action.data } };
    case ActionType.TTLO_V2_EDITOR_DATA_UPDATED:
      let result = { ...state, ticketTLOV2EditorData: { ...state.ticketTLOV2EditorData, ...action.data } };
      return result;
    case ActionType.TTLO_V2_EDITOR_DATA_SAVED:
      return { ...state };
    case ActionType.TTLO_V2_EDITOR_DATA_VALIDATED:
      return { ...state, validation: { ...action.data } };
    case ActionType.TTLO_V2_EDITOR_SET_BOUND_ITEM:
      return { ...state, ticketTLOV2EditorData: { ...state.ticketTLOV2EditorData, ...action.data } };
    default:
      return state;
  }
};

export default updateTicketTTLOV2EditorData;
